import { useCallback, useState } from 'react';
import { StateMessage } from '@matrix-forge/ui/custom/StateMessage';
import { useLoginWithDevoMetadata } from '@/hooks/useLoginWithDevoMetadata';
import { useParentWindowCredentials } from '@/hooks/useParentWindowCredentials';
// import { SentryFeedbackPopover } from './SentryFeedbackPopover';

/** Loading UI for while we wait for the parent window to provide the user info to our app. */
export const UserInfoLoading = () => {
  const [loginWithMetadata, loginResult] = useLoginWithDevoMetadata();
  const [isTimedOut, setIsTimedOut] = useState(false);
  const onTimeout = useCallback(() => setIsTimedOut(true), []);
  useParentWindowCredentials(loginWithMetadata, onTimeout);

  return (
    <>
      <div className="flex flex-col justify-center items-center w-full h-[80vh]">
        {(!!loginResult?.error && (
          <StateMessage
            isError
            isLarge
            isAbsolute
            title="Unable to authenticate user."
            description={String(loginResult.error?.message || '')}
          />
        )) ||
          (!!isTimedOut && (
            <StateMessage
              isError
              isLarge
              isAbsolute
              title="Timed out while authenticating user. Please try reloading the page."
            />
          )) || <StateMessage isLoading isLarge isAbsolute title="Authenticating..." />}
      </div>
      <div className="fixed bottom-0 right-0 m-4 z-2">
        {/* <SentryFeedbackPopover showText /> */}
      </div>
    </>
  );
};
